export default __webpack_public_path__ + "static/media/logo-dark.89b5052c.svg";